'use client';

import { Box } from '@wishket/design-system';
import React, { useState } from 'react';

import { RoleSelect } from './PersonalizedAreaRoleSelect.parts';

import { RoleItem } from '@/shared/types';
import { useRoleQuery } from '@/entities/profile';
import {
  PersonalizedAreaSelectButton,
  ResponsiveListShell,
} from '@/features/Landing';

interface PersonalizedAreaRoleSelectProps {
  selectedRole: RoleItem;
  onRoleChange: (item: RoleItem) => void;
}

const PersonalizedAreaRoleSelect = ({
  selectedRole,
  onRoleChange,
}: PersonalizedAreaRoleSelectProps) => {
  const { data: roleData } = useRoleQuery();
  const categories = roleData?.categories;
  const roles = roleData?.roles;
  const recommendRoles = roleData?.recommendRoles;
  const [isRoleSelectOpen, setIsRoleSelectOpen] = useState(false);

  const roleText = selectedRole.value;

  const onSelectClick = () => setIsRoleSelectOpen((prev) => !prev);

  const closeSelect = () => setIsRoleSelectOpen(false);

  return (
    <Box className="relative">
      <PersonalizedAreaSelectButton text={roleText} onClick={onSelectClick} />
      <ResponsiveListShell isOpen={isRoleSelectOpen} onClose={closeSelect}>
        <RoleSelect
          categories={categories}
          roles={roles}
          recommendRoles={recommendRoles}
          selectedRole={selectedRole}
          onRoleChange={onRoleChange}
          closeSelect={closeSelect}
        />
      </ResponsiveListShell>
    </Box>
  );
};

export default PersonalizedAreaRoleSelect;
